import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import {
  MemoRow,
  NoteContainer,
  RequestButton,
} from '@/components/note-elements';
import { View } from 'react-native';

interface Props {
  memoCollectionCount: number;
  memoPartitionCount: number;
  noteText?: string;
  onPress: () => void;
  showRequest: boolean;
}

export const SearchNote: React.FC<Props> = ({
  showRequest,
  memoCollectionCount,
  memoPartitionCount,
  noteText,
  onPress,
}) => {
  const [styles] = useStyles();

  const hasMemos = memoCollectionCount > 0;

  if (!hasMemos && !showRequest) {
    return null;
  }

  return (
    <View style={styles.container}>
      <NoteContainer>
        {hasMemos ? (
          <MemoRow onPress={onPress}>
            {memoPartitionCount === 1
              ? noteText
              : memoCollectionCount === 1
                ? i18n.t('search_note.memos_in_order_guides.singular')
                : i18n.t('search_note.memos_in_order_guides.plural', {
                    count: memoCollectionCount,
                  })}
          </MemoRow>
        ) : null}
        {showRequest ? (
          <RequestButton
            accessibilityLabel={i18n.t('order_guide_item.request_note')}
            onPress={onPress}
          />
        ) : null}
      </NoteContainer>
    </View>
  );
};

const useStyles = createStyles(() => ({
  container: {
    flexShrink: 1,
    minWidth: 100,
    width: '100%',
  },
}));
